package com.example.mystybag.common.model

open class ListVisualModel(
    val itemText      : String,
    val itemImageLink : String? = null
)